import GiftProducts from './GiftProducts'
import PromocodeApplier from './PromocodeApplier'

import styles from './styles.module.scss'

export default function DiscountControl () {
  return (
    <div className={styles.root}>
      <div className={styles.promo}>
        <PromocodeApplier />
      </div>
      <GiftProducts />
    </div>
  )
}
